export function getReactNativeVersion() {
  throw new Error('getReactNativeVersion is not supported on web');
}
//# sourceMappingURL=getReactNativeVersion.web.js.map